<template>
    <div class="right-table">
        <h1>作业活动风险分级管控清单</h1>
        <div class="line"></div>
        <div class="table" @click="clickTable()">
            <el-table :data="tableData" style="width: 100%" ref="datalist" @mouseover.native="mouseEnter()"
                @mouseout.native="mouseLeave()">
                <el-table-column prop="site" label="部位" width="50" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="risk" label="风险辨识" width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="level" label="风险分级" width="80" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span :style="{ color: scope.row.level == '低风险' ? '#409EFF' : '#E6A23C' }">{{
                            scope.row.level
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="可能导致事故类型" width="90" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="prevention" label="主要防范措施" show-overflow-tooltip>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tableData: [
                {
                    site: "能源站",
                    risk: "管道支架老化或防护失效",
                    level: "低风险",
                    type: "03 机械伤害",
                    prevention: "定期巡查，发现及时维修更换",
                },
                {
                    site: "能源站",
                    risk: "未履行动火审批/看护不到位",
                    level: "一般风险",
                    type: "08 火灾",
                    prevention: "动火作业审批制度",
                },
                {
                    site: "能源站",
                    risk: "起重吊装",
                    level: "低风险",
                    type: "01 物体打击",
                    prevention: "操作规程佩戴安全帽",
                },
                {
                    site: "能源站",
                    risk: "长时间处于噪音环境",
                    level: "低风险",
                    type: "20 其他伤害",
                    prevention: "避免长时间接受噪音",
                },
                {
                    site: "能源站",
                    risk: "设备突然运转/零部件损坏失效或安装不到位",
                    level: "低风险",
                    type: "03 机械伤害",
                    prevention: "操作规程",
                },
                {
                    site: "能源站",
                    risk: "工具放置不合理",
                    level: "低风险",
                    type: "01 物体打击",
                    prevention: "安全放置",
                },
                {
                    site: "能源站",
                    risk: "板式换热器尚未冷却",
                    level: "低风险",
                    type: "07 灼烫",
                    prevention: "操作规程",
                },
                {
                    site: "能源站",
                    risk: "接触带电设备",
                    level: "一般风险",
                    type: "05 触电",
                    prevention: "佩戴绝缘手套",
                },
                {
                    site: "能源站",
                    risk: "未发现消防设施失效",
                    level: "一般风险",
                    type: "08 火灾",
                    prevention: "定期巡查，发现及时维修更换",
                },
                {
                    site: "办公区",
                    risk: "使用办公电气设备，因电气线路老化或人员操作失误，造成人员触电伤害",
                    level: "一般风险",
                    type: "05 触电",
                    prevention: "专业电工规范接线，可靠连接保护接零和保护接地线，设备可靠接地，各级开关正确安装漏电保护器;强化教育培训;张贴警示标识;",
                },
            ],
            rolltimmer: '',
            rollPx: 1,
            rolltime: 30
        };
    },
    methods: {
        autoRoll(stop) {
            if (stop) {
                clearInterval(this.rolltimmer);
                return;
            }
            const table = this.$refs.datalist;
            const divData = table.bodyWrapper;
            this.rolltimmer = setInterval(() => {
                divData.scrollTop += this.rollPx;
                if (divData.clientHeight + divData.scrollTop >= divData.scrollHeight - 1) {
                    setTimeout(() => {
                        divData.scrollTop = 0;
                    }, 1000)
                }
            }, this.rolltime);
        },
        //鼠标进入 停止滚动
        mouseEnter(time) {
            this.autoRoll(true);
        },
        //鼠标离开 开始滚动
        mouseLeave() {
            this.autoRoll();
        },
        clickTable(row) {
            console.log(123);
            this.$router.push({
                path: "/riskActivity",
            })
        }
    },
    mounted() {
        this.autoRoll();
    },
};
</script>
<style lang="less" scoped>
.right-table::v-deep {
    height: 260px;

    h1 {
        margin: 0px 18px 0px;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        line-height: 25px;
        text-shadow: 0px 0px 8px #005ec9;
    }

    .line {
        height: 13px;
        background-image: url(@/assets/images/cockpit/title2.png);
        background-size: contain;
        background-repeat: no-repeat;
    }

    .table {
        margin-top: 10px;
        width: 100%;
        height: 240px;
        background-image: url(@/assets/images/cockpit/table.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding-top: 10px;

        .el-table__body-wrapper {
            height: 185px;
        }

        .el-table {
            width: 95% !important;
            background-color: transparent;
            margin: 0px auto;
            height: 250px;

            &:before {
                background-color: transparent;
            }

            .has-gutter {
                height: 34px;
                background: linear-gradient(180deg,
                        rgba(75, 241, 255, 0) 0%,
                        rgba(36, 222, 255, 0.09) 100%);
                box-shadow: inset 0px -4px 13px 0px rgba(36, 222, 255, 0.5);
            }

            tr {
                background-color: transparent !important;
            }

            th {
                width: 513px;
                height: 34px;
                background-color: transparent;
                border: none;
                padding: 0;
                width: 56px;
                font-size: 14px;
                font-weight: 600;
                color: #00FFF2;
                line-height: 20px;
                text-align: center;
            }

            td {
                height: 45px;
                border-color: #355b86;
                background-color: transparent !important;
                padding: 5px;
                text-align: center;
                font-size: 14px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 45px;
            }

            .cell {
                padding: 0;
            }
        }
    }

}
</style>